module.exports = __webpack_public_path__ + "static/media/Seth-CEO.1b0fa244.png";